import { render, staticRenderFns } from "./totalRequest.vue?vue&type=template&id=30a42cdd"
import script from "./totalRequest.vue?vue&type=script&lang=js"
export * from "./totalRequest.vue?vue&type=script&lang=js"
import style0 from "./totalRequest.vue?vue&type=style&index=0&id=30a42cdd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports